export function changeCheckboxStatus(ids, state) {
  for (var index = 0; index < ids.length; index += 1) {
    $('#' + ids[index]).not(':disabled').prop('checked', state);
  }
}